import { defineMessages } from 'react-intl';

export const messages: {
	clearFilterButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	clearFilterButtonLabel: {
		id: 'search-page.common.ui.clear-filter-button.label',
		defaultMessage: 'Clear filter',
		description: 'Label for button to clear filter options',
	},
});
